export enum EnumServicesQueryKeys {
  CORPORATE_TDAE_INFORMATION = 'CORPORATE_TDAE_INFORMATION',
  CORPORATE_TDAE_VERIFY_INFORMATION = 'CORPORATE_TDAE_VERIFY_INFORMATION',
  CORPORATE_TDAE_RECORDS = 'CORPORATE_TDAE_RECORDS',
  CORPORATE_TDAE_MANDATES = 'CORPORATE_TDAE_MANDATES',
  UNCATEGORIZED_ACCOUNT_TRANSACTIONS = 'UNCATEGORIZED_ACCOUNT_TRANSACTIONS',
  TDAE_TURNOVER_ESTIMATE = 'TDAE_TURNOVER_ESTIMATE',
}
